class ErrorManager {
    static throwError(message) {
        let error = { message }
        throw error;
    }
}

export default ErrorManager;